<template>
  <div id="" class="module-wrapper" v-if="isLoggedIn">
    <div v-if="!showChatPopup">
      <div>
        <!-- Floating button -->
        <el-badge :value="chatCount < 1 ? null : chatCount" class="badge">
          <div class="bubble" @click="openChatPopup">
            <i class="el-icon-chat-dot-round" style="font-size: 50px;"></i>
          </div>
        </el-badge>

      </div>
    </div>
    <div v-if="showChatPopup" class='chatListContainer'>
      <div>
        <div v-if="openType == 1">
          <ChatList @closeChat="closeChat" @openChat="openAgent" />
        </div>
        <div v-if="openType == 2">
          <Chat @closeChat="closeChat" @goBack="goBackToList" />
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import ChatListHeader from './components/chatListHeader.vue'
import ChatList from './chatList.vue'
import Chat from './chat.vue'
import eventBus from '../../../assets/js/eventBus';
export default {
  name: "ChatButton",
  data() {
    return {
      showChatPopup: false,
      openType: 1,
      chatCount: 0,
      isLoggedIn: sessionStorage.getItem("token")
    };
  },
  components: {
    ChatListHeader,
    ChatList,
    Chat
  },
  props: {
    phone1: "",
    phone2: ""
  },
  mounted() {
    this.calcTotalChatCount()
  },
  created() {
    // When count changed from get API
    eventBus.$on("totalChanged", (data) => {
      console.log("total change", data);
      const unreadSystemCount = localStorage.getItem('systemUnread');
      this.chatCount = parseInt(data);
      this.chatCount += unreadSystemCount ? parseInt(unreadSystemCount) : 0;
    });

    // When count changed inside chat
    eventBus.$on("updateTotalCount", () => {
      this.calcTotalChatCount();
    });

    // When logged in
    eventBus.$on("startChat", () => {
      this.isLoggedIn = true;
    })

    // When logged out
    eventBus.$on("endChat", () => {
      this.isLoggedIn = false;
      this.closeChat()
    })
  },
  watch: {
    openType(newV, oldV) {
      localStorage.setItem("chatPage", newV);
    }
  },
  methods: {
    openChatPopup() {
      if (sessionStorage.getItem("token")) {
        this.showChatPopup = !this.showChatPopup
        this.openType = 1;
        localStorage.setItem("chatPage", this.openType);
      }
    },
    closeChat() {
      this.showChatPopup = false;
      this.openType = 1;
    },
    openAgent() {
      this.openType = 2
    },
    goBackToList() {
      this.openType = 1;
    },
    calcTotalChatCount() {
      this.chatCount = 0;
      const agents = JSON.parse(localStorage.getItem('agent_list'));

      if (agents && agents.length) {
        agents.forEach(item => {
          this.chatCount = parseInt(this.chatCount) + parseInt(item.count);
        })
      }
      const unreadSystemCount = localStorage.getItem('systemUnread');
      const unread = (unreadSystemCount ? parseInt(unreadSystemCount) : 0)
      this.chatCount = parseInt(this.chatCount) + unread;
    }
  }
};
</script>
<style scoped>
.module-wrapper {
  position: fixed;
  bottom: 0;
  right: 60px;
  z-index: 100;
}

@keyframes slideInFromBottom {
  from {
    transform: translateY(100%);
    opacity: 0;
  }

  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.chatListContainer {
  width: 400px;
  border: 1px solid #cecece;
  z-index: 100;
  border-radius: 10px 10px 0px 0px;
  height: 85vh;
  background-color: #fff;
  margin-bottom: 30px;
  position: fixed;
  bottom: 0;
  right: 60px;
  border-radius: 15px;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  animation: slideInFromBottom 0.3s ease-out forwards;
}

.bubble {
  position: fixed;
  /* Ensure it's fixed to the viewport */
  bottom: 30px;
  right: 60px;
  background: var(--baseColor);
  color: #fff;
  padding: 10px;
  border-radius: 50%;
  cursor: pointer;
  z-index: 1000;
}

.badge {
  position: absolute;
  bottom: 100px;
  right: 10px;
  z-index: 1001;
}
</style>


// WEBPACK FOOTER //
// src/components/module/chat/chatButton.vue